import { SNACKBAR } from "../../ActionType/SnackBar";

export const setSnackbar = (payload) => {
  return {
    type: SNACKBAR,
    payload,
  };
};
